import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isSSR } from '../../common/utils';
import { Logger } from '../../common/utils/logger';
var IndexedDBService = /*#__PURE__*/function () {
  function IndexedDBService(dbName, storeName) {
    var _this = this;
    _classCallCheck(this, IndexedDBService);
    _defineProperty(this, "db", null);
    _defineProperty(this, "isBooted", false);
    _defineProperty(this, "isAvailable", false);
    _defineProperty(this, "onConnectionErrorHandler", function (reject) {
      return function (event) {
        Logger.warn('Error opening database.');
        reject(event);
      };
    });
    _defineProperty(this, "onConnectionSuccessHandler", function (connection, resolve) {
      return function (event) {
        _this.db = connection.result;
        resolve();
      };
    });
    _defineProperty(this, "onConnectionUpgradeNeededHandler", function (request) {
      return function (event) {
        _this.db = request.result;
        _this.db.createObjectStore(_this.storeName, {
          keyPath: 'id'
        });
      };
    });
    _defineProperty(this, "onGetRecordErrorHandler", function (reject) {
      return function () {
        var getErrorMessage = "Failed to perform a get transaction on IndexedDB: ".concat(_this.dbName, " + ").concat(_this.storeName);
        Logger.warn(getErrorMessage);
        reject(getErrorMessage);
      };
    });
    _defineProperty(this, "onGetRecordSuccessHandler", function (getRequest, resolve) {
      return function () {
        resolve(getRequest.result);
      };
    });
    _defineProperty(this, "onSetRecordErrorHandler", function (reject) {
      return function () {
        var errorMessage = "Failed to perform a set transaction on IndexedDB: ".concat(_this.dbName, " + ").concat(_this.storeName);
        Logger.warn(errorMessage);
        reject(errorMessage);
      };
    });
    _defineProperty(this, "onSetRecordSuccessHandler", function (resolve) {
      return function () {
        resolve();
      };
    });
    this.dbName = dbName;
    this.storeName = storeName;
    this.isAvailable = this.getIsDBAvailable();
    this.isBooted = false;
    this.bootUpPromiseCache = null;
  }
  return _createClass(IndexedDBService, [{
    key: "boot",
    value: function () {
      var _boot = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.isAvailable) {
                _context.next = 3;
                break;
              }
              Logger.warn('IndexedDB is not available');
              return _context.abrupt("return");
            case 3:
              if (!this.isBooted) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              if (this.bootUpPromiseCache) {
                _context.next = 18;
                break;
              }
              this.bootUpPromiseCache = this.openDB();
              _context.prev = 7;
              _context.next = 10;
              return this.bootUpPromiseCache;
            case 10:
              this.isBooted = true;
              _context.next = 18;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](7);
              this.isBooted = false;
              Logger.warn('Error booting up IndexedDB.');
              throw _context.t0;
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[7, 13]]);
      }));
      function boot() {
        return _boot.apply(this, arguments);
      }
      return boot;
    }()
  }, {
    key: "getIsDBAvailable",
    value: function getIsDBAvailable() {
      return !isSSR() && !!window.indexedDB;
    }
  }, {
    key: "openDB",
    value: function () {
      var _openDB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var request = indexedDB.open(_this2.dbName, 1);
                request.onerror = _this2.onConnectionErrorHandler(reject);
                request.onsuccess = _this2.onConnectionSuccessHandler(request, resolve);
                request.onupgradeneeded = _this2.onConnectionUpgradeNeededHandler(request);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function openDB() {
        return _openDB.apply(this, arguments);
      }
      return openDB;
    }()
  }, {
    key: "getRecord",
    value: function () {
      var _getRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(recordKey) {
        var _this3 = this;
        var fetchTransaction, recordStore, fetchedRecord;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              if (this.isBooted) {
                _context3.next = 4;
                break;
              }
              _context3.next = 4;
              return this.boot();
            case 4:
              if (this.db) {
                _context3.next = 6;
                break;
              }
              throw new Error('Database is not opened');
            case 6:
              fetchTransaction = this.db.transaction([this.storeName]);
              recordStore = fetchTransaction.objectStore(this.storeName);
              fetchedRecord = new Promise(function (resolve, reject) {
                var request = recordStore.get(recordKey);
                request.onerror = _this3.onGetRecordErrorHandler(reject);
                request.onsuccess = _this3.onGetRecordSuccessHandler(request, resolve);
              });
              return _context3.abrupt("return", fetchedRecord);
            case 12:
              _context3.prev = 12;
              _context3.t0 = _context3["catch"](0);
              Logger.error("Error fetching record from database. ".concat(_context3.t0.message || ''));
              throw _context3.t0;
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 12]]);
      }));
      function getRecord(_x) {
        return _getRecord.apply(this, arguments);
      }
      return getRecord;
    }()
  }, {
    key: "setRecord",
    value: function () {
      var _setRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(recordKey) {
        var _this4 = this;
        var _setRecord2;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              if (this.isBooted) {
                _context4.next = 4;
                break;
              }
              _context4.next = 4;
              return this.boot();
            case 4:
              if (this.db) {
                _context4.next = 6;
                break;
              }
              throw new Error('Database is not opened');
            case 6:
              _setRecord2 = new Promise(function (resolve, reject) {
                var setTransaction = _this4.db.transaction([_this4.storeName], 'readwrite');
                var objectStore = setTransaction.objectStore(_this4.storeName);
                var request = objectStore.add('SET-BY-PACKAGE', recordKey);
                request.onerror = _this4.onSetRecordErrorHandler(reject);
                request.onsuccess = _this4.onSetRecordSuccessHandler(resolve);
              });
              return _context4.abrupt("return", _setRecord2);
            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              Logger.warn("Error setting record in database. ".concat(_context4.t0.message || ''));
              throw _context4.t0;
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 10]]);
      }));
      function setRecord(_x2) {
        return _setRecord.apply(this, arguments);
      }
      return setRecord;
    }()
  }]);
}();
var BSCIndexedDB = new IndexedDBService('BSCIndexedDB', 'InternalStorageKeys');
export { BSCIndexedDB, IndexedDBService };